module.exports = "https://99designs-start-assets.imgix.net/js/583ea3771a703c8a7831a586f6a89027.jpg";